"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessDefinitionHttpClientNode = void 0;
const fs = require("fs");
const ProcessDefinitionHttpClient_1 = require("./ProcessDefinitionHttpClient");
class ProcessDefinitionHttpClientNode extends ProcessDefinitionHttpClient_1.ProcessDefinitionHttpClient {
    async deployFiles(filePaths, overwriteExisting, identity) {
        const filesPathsToDeploy = typeof filePaths === 'string' ? [filePaths] : filePaths;
        const xmlPromises = [];
        for (const filePath of filesPathsToDeploy) {
            const xmlPromise = fs.promises.readFile(filePath, 'utf-8');
            xmlPromises.push(xmlPromise);
        }
        let xmls;
        try {
            xmls = await Promise.all(xmlPromises);
        }
        catch (error) {
            throw new Error(`Could not read file: ${error.message}`);
        }
        return this.persistProcessDefinitions(xmls, overwriteExisting, identity);
    }
}
exports.ProcessDefinitionHttpClientNode = ProcessDefinitionHttpClientNode;
//# sourceMappingURL=ProcessDefinitionHttpClientNode.js.map